import { ChangeEvent, FC, useState } from 'react';
import { styled } from 'styled-components';
import SearchIconSVG from '@/assets/images/search.svg?react';
import { palette } from '@/constants/styles';
import { useDebounce } from '@/hooks';

interface ISearchInput {
	value: string;
	props?: Record<string, string>;
	onChange: (newValue: string) => void;
}

const SearchInput: FC<ISearchInput> = ({ value, props, onChange }) => {
	const [innerValue, setInnerValue] = useState<string>(value || '');
	const debounce = useDebounce(onChange, 500);

	const onInnerChange = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		setInnerValue(value);
		debounce(value);
	};

	return (
		<Container $paddingLeft={props?.paddingLeft}>
			<SearchIcon $left={props?.left} />
			<Input placeholder="Search" value={innerValue} onChange={onInnerChange} />
		</Container>
	);
};

const Container = styled.div<{ $paddingLeft?: string }>`
	display: flex;
	position: relative;
	padding-left: ${({ $paddingLeft }) => ($paddingLeft ? $paddingLeft : '54px')};
`;

const SearchIcon = styled(SearchIconSVG)<{ $left?: string }>`
	height: 13px;
	width: 13px;
	position: absolute;
	left: ${({ $left }) => ($left ? $left : '68px')};
	top: 8px;
`;

const Input = styled.input`
	border-radius: 12px;
	background-color: ${palette.primaryGray};
	border: none;
	font-size: 14px;
	color: black;
	font-weight: 200;
	padding: 0 34px;
	width: 275px;
	height: 28px;

	::placeholder {
		font-size: 14px;
		color: black;
		font-weight: 200;
	}

	:focus {
		outline: 0;
	}
`;

export default SearchInput;
